import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ThingActivatorsInterface} from '@app/app/shared/interfaces/thing/thing-activator.interface';
import {CommandsService} from '@app/app/shared/services/commands.service';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';

@Component({
  templateUrl: './park-activator-controls.html',
  selector: 'park-activator-controls'
})

export class ParkActivatorControlsComponent implements OnInit, OnDestroy {
  @Input() public activators: ThingActivatorsInterface[];
  @Input() public parkId: string;
  @Input() public id: string;
  @Input() public color: string;
  objectKeys = Object.keys;

  private timerSub: Subscription;

  public isRunningAuto = false;

  private MODE_AUTO = 'auto';

  private interval;

  public sortedActivators = [];

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  public isAllAuto() {
    let isAuto = true;

    Object.keys(this.activators).forEach((activatorId) => {
      if (this.activators[activatorId].md !== this.MODE_AUTO) {
        isAuto = false;
      }
    });

    if (isAuto && this.isRunningAuto) {
      this.isRunningAuto = false;
      this.cdRef.detectChanges();
    }

    return isAuto;
  }

  ngOnInit() {
    this.sortActivators();

    this.interval = setInterval(() => {
      this.updateActivators();
    }, 1000);
  }

  public updateActivators() {
    Object.keys(this.activators).forEach((activatorId) => {
      const activator = this.activators[activatorId];

      this.sortedActivators.forEach((feat) => {
        if (activatorId === feat[0]) {
          feat[1] = activator;
        }
      });
    });
  }

  public sortActivators() {
    Object.keys(this.activators).forEach((activatorId) => {
      const activator = this.activators[activatorId];

      this.sortedActivators.push(
        [activatorId, activator, parseInt(activator.board || 0, 10), parseInt(Object.values(activator.io).join(), 10)]
      );
    });

    // sort by sort order, then by name
    this.sortedActivators.sort((a, b) => {
      const board = a[2] - b[2];

      if (board !== 0) {
        return board;
      }

      return a[3] - b[3];
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/features/activators/park-activator-controls.component.ts